const varGroups = {
  'wp-adminbar': {
    selector: '#wpadminbar'
  },
  'icf-navbar': {
    selector: '#main-nav'
  },
  'icf-global-header': {
    selector: '#icf-global-header'
  }
} satisfies Record<string, { selector: string }>

const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) {
    for (const [name, varGroup] of Object.entries(varGroups)) {
      if (!entry.target.matches(varGroup.selector)) {
        continue
      }
      const isFixed = ['fixed', 'sticky'].includes(
        getComputedStyle(entry.target).position
      )
      const variables = {
        [`${name}-width`]: `${entry.contentRect.width}px`,
        [`${name}-fixed-width`]: `${isFixed ? entry.contentRect.width : 0}px`,
        [`${name}-height`]: `${(entry.target as HTMLElement).offsetHeight}px`,
        [`${name}-fixed-height`]: `${isFixed ? entry.contentRect.height : 0}px`
      }
      for (const [varName, value] of Object.entries(variables)) {
        document.documentElement.style.setProperty(`--${varName}`, value)
      }
    }
  }
})

for (const varGroup of Object.values(varGroups)) {
  // Only observe the first occurrence. This is by design
  const el = document.querySelector(varGroup.selector)
  if (el) {
    resizeObserver.observe(el, {
      box: 'border-box'
    })
  }
}
